export default "__VITE_ASSET__DYZ$PGD___"